export default __webpack_public_path__ + "static/yelyzaveta-veis-37f195019bb5febb4e377dc7af886bc1.png";